import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useState } from 'react';
import Home1 from './pages/home1';
import AboutPage from './pages/innerpages/about';
import ContactPage from './pages/innerpages/contact';
import ServicesPage from './pages/innerpages/services';

import Home3 from './pages/home3_construction';
import Home6 from './pages/home6_furniture';
// import ArchitectureInteriorDesign from './pages/innerpages/ArchitectureInteriorDesign';
import Loader from './components/common/Loader';

import Footer from './components/home2/Footer';
import ProjectPage from './pages/project';
import SingleProject from './pages/singleproject';
import HomeInteriorsPage from './pages/services/HomeInteriors';
import CorporateInteriorsPage from './pages/services/CorporateInteriors';
import CommercialRestaurantInteriorsPage from './pages/services/CommercialRestaurantInteriors';
import ArchitectureInteriorDesignPage from './pages/services/ArchitectureInteriorDesign';



function App() {


  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Home1 />} />
          <Route path="/about" element={< Home6 />} />
          <Route path="/services" element={<Home3 />} />
          <Route
            path="/projects"
            element={

              <ProjectPage />

            }
          />
          <Route path="/project/:id" element={<SingleProject />} />

          <Route path="/services/home-interiors" element={<HomeInteriorsPage />} />
          <Route path="/services/corporate-interiors" element={<CorporateInteriorsPage />} />
          <Route path="/services/commercial-restaurant-interiors" element={<CommercialRestaurantInteriorsPage />} />
          <Route path="/services/architecture-interior-design" element={<ArchitectureInteriorDesignPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
